import { Vue, MsgBox } from '../../app.vues'

import SwbFundTransActRecList from './FundTransActRecList';
Vue.regist(SwbFundTransActRecList);

export function openFundTransActRecDlg(filter, callback) {
    //
    Vue.$showDialog({
        title: '资金往来操作记录 - 查看',
        width: -160,
        height: -160,
        showCloseBtn: true,
        okVisible: false,
        cancelText: "关闭",
        template: '<div class = "">' +
        '<swb-fund-trans-act-rec-list :filter="filter" ref="swb_fund_trans_act_rec_list"></swb-fund-trans-act-rec-list>' +
        '</div>',
        data: {
            filter: filter
        },
        okClicked: function () {
        },
        lifecycle: {
            created: function () {
            }
        }
    });
}

import SwbPayVoucherInfoPdf from './PayVoucherInfoPdf';
Vue.regist(SwbPayVoucherInfoPdf);

export function openPayVoucherInfoPdfDlg(voucherId, payVoucherFlag, callback) {
    //
    Vue.$showDialog({
        title: '资产付款单 - 下载',
        width: 1200,
        height: 800,
        showCloseBtn: true,
        okVisible: false,
        cancelText: "关闭",
        template: '<div class = "">' +
        '<swb-pay-voucher-info-pdf :voucherId="voucherId" :payVoucherFlag="payVoucherFlag" ref="swb_pay_voucher_info_pdf"></swb-pay-voucher-info-pdf>' +
        '</div>',
        data: {
            voucherId: voucherId,
            payVoucherFlag: payVoucherFlag
        },
        okClicked: function () {
        },
        lifecycle: {
            created: function () {
            }
        }
    });
}

import SwbPayVoucherListForSelect from './PayVoucherListForSelect';
Vue.regist(SwbPayVoucherListForSelect);
// 预付单选择
export function showPayVoucherListForSelectDlg(dlgConfig, callback) {
    let doPrePay = dlgConfig["doPrePay"];
    let title = dlgConfig["title"] || null;
    title = Utils.isNoB(title) ? (Utils.isTrue(doPrePay) ? '金额 - 预付' : '预付单 - 选择') : title;
    let okVisible = true;
    let cancelText = '取消';
    if(Utils.isTrue(doPrePay)) {
        okVisible = false;
        cancelText = '关闭';
    }
    let showBtn = dlgConfig["showBtn"];
    let payPreFilter = dlgConfig["payPreFilter"];
    //
    let checkBox = dlgConfig["checkBox"];
    let selectIds = dlgConfig["selectIds"];
    let filter = dlgConfig["filter"];
    let parentSelf = dlgConfig["parentSelf"];
    let parentPath = dlgConfig["parentPath"];
    let selectPrftCenterCode = dlgConfig["selectPrftCenterCode"]; // 是否展示选择利润中心的按钮，默认不显示
    let settleProofId = dlgConfig["settleProofId"]; // 结算单按id
    let prftCenterCode = dlgConfig["prftCenterCode"] || null; // 结算单中的利润中心
    let theDlg = Vue.$showDialog({
        title: title,
        width: -200,
        height: 900,
        showCloseBtn: true,
        cancelVisible: true,
        cancelText: cancelText,
        okVisible: okVisible,
        template: '<swb-pay-voucher-list-for-select :showBtn="showBtn" :settleProofId="settleProofId" :prftCenterCode="prftCenterCode" :selectPrftCenterCode="selectPrftCenterCode" :payPreFilter="payPreFilter" :checkBox="checkBox" :selectIds="selectIds" :filter="filter" :parentSelf="parentSelf" :parentPath="parentPath" @jumpTradeVoucherList="jumpTradeVoucherList" ref="swb_pay_voucher_list_for_select"></swb-pay-voucher-list-for-select>',
        data: {
            showBtn: showBtn,
            settleProofId: settleProofId,
            prftCenterCode: prftCenterCode,
            selectPrftCenterCode: Utils.isTrue(selectPrftCenterCode),
            payPreFilter: payPreFilter,
            checkBox: checkBox,
            selectIds: selectIds,
            filter: filter,
            parentSelf: parentSelf,
            parentPath: parentPath
        },
        okClicked: function () {
            let result = this.$refs.swb_pay_voucher_list_for_select.getDlgResult() || {};
            if(result.type === 'info') {
                let payVouchers = result.data;
                callback(payVouchers);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        },
        cancelClicked: function () {
            if(!Utils.isTrue(okVisible)) {
                let result = this.$refs.swb_pay_voucher_list_for_select.getRefreshResult() || {};
                if(result.type === 'info') {
                    let refresh = result.data || false;
                    callback(refresh);
                } else {
                    MsgBox.warning(result.message);
                }
            }
        },
        methods: {
            jumpTradeVoucherList: function () {
                theDlg.close();
            }
        }
    });
}



//////////////////
// WEBPACK FOOTER
// ./src/compo/payment/ActRecDlg.js
// module id = 146
// module chunks = 0